module.exports = __webpack_public_path__ + "img/peixun.79d8ef4d.png";